package com.eladfinish.bible.contest.screens.search.ai.remote

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ResponsesApiRequest(
    val model: String,
    val prompt: PromptReference,
)

@Serializable
data class PromptReference(
    val id: String,
    val version: String? = null,
    val variables: Map<String, String>,
)

@Serializable
data class ResponsesApiResponse(
    val output: List<ResponseOutputItem> = emptyList(),
)

@Serializable
data class ResponseOutputItem(
    val content: List<ResponseContentItem> = emptyList(),
)

@Serializable
data class ResponseContentItem(
    val type: String,
    val text: String? = null,
)

@Serializable
data class AiSearchSuggestionResponse(
    @SerialName("expression")
    val expression: String,
    @SerialName("explanation")
    val explanation: String? = null,
)

@Serializable
data class AiSearchRequest(
    val prompt: String,
)

@Serializable
data class AiSearchResponse(
    val expression: String? = null,
    val explanation: String? = null,
    val isValid: Boolean,
    val errorMessage: String? = null,
    val confidence: Double? = null,
)
